export const isValidPhone = ({ phone, format, dialCode }) =>
  phone.length === format.replace(/[\s()+]/g, '').length &&
  phone.startsWith(dialCode);

export default isValidPhone;
